export default "__VITE_ASSET__BMg8J82t__"